/**
 * Toggles z-index priority of header and main element
 * @function
 * @param  {'on'|'off'} toggled - On means header has higher index, off means main element does
 * @returns void
 */

export const headerOverlayToggle = (toggled: 'on' | 'off'): void => {
  const target = document.querySelector('main');

  if (toggled === 'off') {
    target?.classList.add('topIndex');
    return;
  }

  target?.classList.remove('topIndex');
};
